<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiAccountPlus } from "@mdi/js";
export default {
  name: "MdiAccountPlus",
  data() {
    return {
      svgPath: mdiAccountPlus,
    };
  },
};
</script>
